import React from 'react';
import HouseAddEdit from '../../../components/admin/HouseAddEdit/HouseAddEdit';
import styles from './AdminHouseCreate.module.scss';
const AdminHouseCreate = () => {
  return <HouseAddEdit />;
};

export default AdminHouseCreate;
